/**
 * Bin Picker: better things come out of containers.
 *
 * The seed instance for the loot lever, and the third perk the issue names. It pays out somewhere
 * the other five do not touch at all, which is the point of a closed field union: a perk reaching
 * the loot roll is a lever, not a special case in the roll.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const BIN_PICKER = {
  id: 'binPicker',
  branch: 'scavenging',
  tier: 2,
  title: 'Bin Picker',
  blurb: 'An eye for the tin at the back. Most of them are still sealed. Most.',
  maxRanks: 3,
  minLevel: 7,
  requires: ['packMule'],
  statGrants: {},
  effects: [{ field: 'lootQuality', perRank: 0.07, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
